module.exports = __webpack_public_path__ + "static/white_dragon_wyrmling-5be51f9f92ee0dfe165e1b98bf77cfbe.jpg";